import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import TextInputBox from '@components/TextInputBox';

import { isValidEmail } from '@utils/validation';

const messages = defineMessages({
  helperText: {
    id: 'emailSelector.helperText',
    defaultMessage:
      "They'll need to verify their email before they can access your record.",
  },
  enterEmail: {
    id: 'shareEmailInput.enterEmail',
    defaultMessage: 'Enter Email Address',
  },
  verifyEmail: {
    id: 'shareEmailInput.verifyEmail',
    defaultMessage: 'Verify Email Address',
  },
  notMatching: {
    id: 'shareEmailInput.notMatching',
    defaultMessage: 'Emails do not match',
  },
  invalidEmail: {
    id: 'GLOBAL.invalidEmail',
    defaultMessage: 'Invalid email',
  },
});

interface EmailInputProps {
  emails: {
    email1: string;
    email2: string;
  };
  onChange: React.Dispatch<
    React.SetStateAction<{
      email1: string;
      email2: string;
    }>
  >;
}

export default function EmailInput({ emails, onChange }: EmailInputProps) {
  const { formatMessage } = useIntl();
  const { email1, email2 } = emails;

  const hasError1 = email1.length > 1 && !isValidEmail(email1);
  const hasError2 =
    email2.length > 1 &&
    email1.length > 1 &&
    (!isValidEmail(email2) || email1 !== email2);

  const handleChange1 = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = event.target.value;
    onChange((prev) => ({ ...prev, email1: value }));
  };

  const handleChange2 = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = event.target.value;
    onChange((prev) => ({ ...prev, email2: value }));
  };

  return (
    <>
      <TextInputBox
        autoComplete="off"
        error={hasError1}
        fullWidth
        helperText={formatMessage(
          hasError1 ? messages.invalidEmail : messages.helperText
        )}
        label={formatMessage(messages.enterEmail)}
        onChange={handleChange1}
        required
        type="email"
        value={email1}
      />

      <TextInputBox
        autoComplete="off"
        error={hasError2}
        fullWidth
        helperText={
          email1 !== email2
            ? formatMessage(messages.notMatching)
            : email2.length > 1 && !isValidEmail(email2)
              ? formatMessage(messages.invalidEmail)
              : undefined
        }
        label={formatMessage(messages.verifyEmail)}
        onChange={handleChange2}
        required
        type="email"
        value={email2}
      />
    </>
  );
}
